import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import React from "react";
import type { ProjectDataItem } from "@ServerTypes/projects/project.schema";
import type { SpaceDataItem } from "@ServerTypes/spaces/space.schema";

/** ProjectData extends the backend ProjectDataItem with frontend-only state */
export interface ProjectData extends ProjectDataItem {
  isDataFetched: boolean;
}

/** Breadcrumb item — text may be a string, translated string, or JSX element */
export interface BreadCrumbItem {
  text?: React.ReactNode;
  link?: string;
  showTooltip?: boolean;
  tooltipData?: string;
  template?: () => React.ReactNode;
}

const projectDataSlice = createSlice({
  name: "projectData",
  initialState: { isDataFetched: false } as ProjectData,
  reducers: {
    setProjectData: (_state: ProjectData, action: PayloadAction<Omit<ProjectData, "isDataFetched"> & Partial<ProjectData>>) => ({
      ...action.payload,
      isDataFetched: true,
    }),
  },
});

const allSpacesInProjectSlice = createSlice({
  name: "allSpacesInProject",
  initialState: [] as SpaceDataItem[],
  reducers: {
    setAllSpacesInProjects: (_state: SpaceDataItem[], action: PayloadAction<SpaceDataItem[]>) => action.payload,
  },
});

const spaceDataSlice = createSlice({
  name: "spaceData",
  initialState: [] as SpaceDataItem[],
  reducers: {
    setSpaceData: (_state: SpaceDataItem[], action: PayloadAction<SpaceDataItem[]>) => action.payload,
  },
});

const breadCrumbDataSlice = createSlice({
  name: "breadCrumbData",
  initialState: [] as BreadCrumbItem[],
  reducers: {
    setBreadCrumbData: (_state: BreadCrumbItem[], action: PayloadAction<BreadCrumbItem[]>) => action.payload,
  },
});

export const { setProjectData } = projectDataSlice.actions;
export const { setAllSpacesInProjects } = allSpacesInProjectSlice.actions;
export const { setSpaceData } = spaceDataSlice.actions;
export const { setBreadCrumbData } = breadCrumbDataSlice.actions;

export const projectData = projectDataSlice.reducer;
export const allSpacesInProject = allSpacesInProjectSlice.reducer;
export const spaceData = spaceDataSlice.reducer;
export const breadCrumbData = breadCrumbDataSlice.reducer;

export default breadCrumbDataSlice.reducer;
